export const locale = {
    id: 'nl-BE',
    prefix: '',
    mailDomain: 'be',
};
